export enum RenderHeaderMode {
  SINGLE,
  DOUBLE,
}
